import request from '../request';
import { ImportModalForm } from '../../routes/Setup/Business/TravelAgencyAccounts/TravelAgencyAccounts';
import Api, { handleData, handleError } from '../Api';

import { TravelAgencyAccount } from './types';
import { url } from './config';

type TravelAgenciesUploadBody = ImportModalForm & { parsedData: Array<TravelAgencyAccount> };

class ExtendedApi extends Api<TravelAgencyAccount> {
    upload(importData: TravelAgenciesUploadBody) {
        return request.post(`${url}/upload`, importData).then(handleData).catch(handleError);
    }
}

const api = new ExtendedApi(url);

export default api;

export { TravelAgenciesUploadBody };
